import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import { IRole } from "../../../models/role/response";
import { getUserStatus } from "../../../models/user/enum";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import TrademarkManagerContext from "../../../context/trademark-manager/context";

interface IProps {}

const TrademarkManagerFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(TrademarkManagerContext);
  const [roles, setRoles] = useState<IRole[]>([]);
  const [rolesLoading, setRolesLoading] = useState<boolean>(false);
  const { direction } = useContext(AppContext);
  const statuses = [1, 2];

  return (
    <Form
      formId="trademark-manager-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status
              ? {
                  name: "status",
                  value: data.status,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col span={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
         
        </Col>
      </Row>
    </Form>
  );
};

export default TrademarkManagerFilter;
